import React from 'react';  // import the React library
 
const picStyle = {
    marginLeft: "auto", 
    marginRight: "auto", 
    width: "25em", 
    height: "20em"
}

function Image(props) {
    return (
<img src={process.env.PUBLIC_URL + props.picURL} style={picStyle} alt={props.alt}/>
    )
}

export default Image;


// 